import React from 'react'
import logo from "../assets/vlogo.png"

const Cover = ()=> {
    const isMobile = window.innerWidth <= 500;
    return (
        <div className="cover">
            
            {(isMobile)?(<h2 className="text-center covertitle">Departments of<br></br> ECE and BME <br></br>Proudly Presents</h2>):(<h2 className="text-center covertitle">Departments of ECE and BME<br></br>Proudly Presents</h2>)}
            <img src={logo} width="350rem" alt="vidyutrenz-logo"></img>
            <h2 className="text-center covertitle">V I D Y U T R E N Z</h2>
            <h4 className="text-center title">A National Level Technical Symposium</h4>
            <h3 className="text-center text-white mb-4">May 8, 2021</h3>
        </div>
    )
}

export default Cover;
